import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';

const endpointPrefix =  'mssp/';
const productPrefix = 'product/';
const msspTenantAPI = {
  getMsspProductDetails(data: any) {
    const reqEndPoint = `${endpointPrefix}getmsspproductservices`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  productTransfer(data: any) {
    const reqEndPoint = `${productPrefix}product-transfer`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  deleteProduct(data: any) {
    const reqEndPoint = `${productPrefix}product-delete`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  convertToMssp(data: any) {
    const reqEndPoint = `${endpointPrefix}allocatemsspproductservices`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  getMsspPrefilter(data: any, needAll: boolean, nonMssp: boolean) {
    let reqEndPoint = '';
    if (needAll) {
      reqEndPoint = data ? `${endpointPrefix}get-mssp-prefilter?isforced=true&allMSSP=true&allTenant=true` : `${endpointPrefix}get-mssp-prefilter?allMSSP=true&allTenant=true`;
      reqEndPoint = nonMssp ? reqEndPoint.concat('&nonMSSPTenant=true') : reqEndPoint;
    } else {
      reqEndPoint = data && nonMssp ? `${endpointPrefix}get-mssp-prefilter?isforced=true&nonMSSPTenant=true` : !data && nonMssp ? `${endpointPrefix}get-mssp-prefilter?nonMSSPTenant=true` :
      data && !nonMssp ? `${endpointPrefix}get-mssp-prefilter?isforced=true` : `${endpointPrefix}get-mssp-prefilter`;
    }
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getMsspAppliances(data: any) {
    const reqEndPoint = `${endpointPrefix}get-mssp-appliances`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  postFilterPreference(data: any, preferenceSource: string = 'MSSPMGMT') {
    const reqEndPoint = 'mssp/savemsspuserpreference';
    const reqBody = {
      preferenceSource,
      preferenceData: data,
    };
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, reqBody);
  },
  getMsspPreferenceFilter(preferenceSource: string = 'MSSPMGMT') {
    const reqEndPoint = `mssp/getmsspuserpreference?source=${preferenceSource}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  // getMsspDetails() {
  //   const reqEndPoint = `${endpointPrefix}getmsspdetails`;
  //   return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  // },
  // getMsspStat() {
  //   const reqEndPoint = `${endpointPrefix}getmsspstat`;
  //   return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  // },
  getUserGroupDetails() {
    const reqEndPoint = 'users/get-usergroup-details-for-user';
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  addMssp(data: any) {
    const reqEndPoint = 'users/add-user';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  editMssp(data: any) {
    const reqEndPoint = 'mssp/update-MSSP-Details';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  addTenant(data: any) {
    const reqEndPoint = 'products/create-product-group';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  editTenant(data: any) {
    const reqEndPoint = 'products/update-tenant-address';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  getMsspFormDetails(id: any) {
    const reqEndPoint = `${endpointPrefix}mssp-user-detail?msspId=${id}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getTenantFormDetails(id: any) {
    const reqEndPoint = `products/get-tenant-address-info?productGroupId=${id}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  getPrefilList() {
    const reqEndPoint = 'mssp/get-mssp-prefilter';
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  getProductServicesList(id: any, service:any, mode: any) {
    const reqEndPoint = service === '' ? `mssp/applicable-mssp-product-services?TenantID=${id}&Mode=${mode}` :
    `mssp/applicable-mssp-product-services?TenantID=${id}&ServiceId=${service}&Mode=${mode}`;
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  addProductProvision(data: any) {
    const reqEndPoint = 'mssp/provision-mssp-product';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  editProductProvision(data: any) {
    const reqEndPoint = 'mssp/allocatemsspproductservices';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  getCountryStateList() {
    const reqEndPoint = 'get-country?languagecode=EN&iswcm=NO';
    return ApiServiceWrapper.get<MswApiStatusResponse>(`${reqEndPoint}`);
  },
  console(data:any) {
    const reqEndPoint = 'generate-cscaccesscode';
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
  updateBackupChoices(data: any) {
    const reqEndPoint = `${productPrefix}update-backup-choices`;
    return ApiServiceWrapper.post<MswApiStatusResponse>(`${reqEndPoint}`, data);
  },
};

export default msspTenantAPI;
